<template>
	<div class="agoraDesBox">
		<div class="banner">
			<p class="txt">MODEL MARKETPLACE<br />模型市场</p>
		</div>
		<div class="titleList flexBox"><router-link to="/agora"
				class="txt">模型市场</router-link><i>></i><span>{{des.subtitle}}</span></div>
		<div class="desBox">
			<div class="name">{{des.name}}</div>
			<div class="time">{{des.createTime}}</div>
			<div class="txt ql-editor" v-html="des.description" style="white-space: pre-wrap;"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'AgoraDes',
		components: {

		},
		data() {
			return {
				des: {}
			}
		},
		mounted() {
			var id = this.$route.query.id;
			if (id != undefined) {
				this.$req("get", "/api/cms/model/detail/" + id).then((res) => {

					this.des = res.data
				})
			}
		}
	}
</script>

<style scoped>
	@import url("../../../assets/css/portal/agoraDes.css");
</style>